import { Box, Menu, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";
import IconifyLegacy from "../iconify/iconify-legacy";
import { LabelColor } from "../label";
import LabelLegacy from "../label/labelLegacy";
import { tableStatusColor } from "src/utils/getColorByStatus";

type Props = {
  options: string[];
  selectedOption: string;
  onChange: (opt: string) => void;
}

function ChipSelectOption({
  options,
  selectedOption,
  onChange
}:Props){
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [op, setOp] = useState<any>(selectedOption);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (opt: any) => {
    if(opt !== op){
      onChange(opt)
      setOp(opt);
    }
    setAnchorEl(null);
  };

  return (
    <>
      <Box onClick={(e: any) => handleClick(e)}>
        <LabelLegacy
          variant="filled"
          sx={{
            borderRadius: 10,
            "&:hover": {
              cursor: "pointer",
            },
            minHeight: '25px',
            fontSize: '14px',
          }}
          color={tableStatusColor(op).color as LabelColor}
          endIcon={<IconifyLegacy icon="material-symbols:expand-more" />}
        >
          {(op)}
        </LabelLegacy>
      </Box>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        {options.map((option:any) => (
          <MenuItem onClick={() => handleSelect(option.tradingName)}>
            <Typography>{option.tradingName}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ChipSelectOption;
